"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToWpx = exports.getHeader2dArray = exports.flattenColumns = void 0;
/**
 * 扁平化列
 */
var flattenColumns = function (_a) {
    var columns = _a.columns, _b = _a.childrenField, childrenField = _b === void 0 ? 'children' : _b;
    var newColumns = [];
    var level = [];
    var flatten = function (_columns, index) {
        if (index === void 0) { index = 0; }
        level[index] = true;
        index += 1;
        _columns.forEach(function (column) {
            var childColumns = column[childrenField];
            if (childColumns && childColumns.length > 0) {
                flatten(childColumns, index);
            }
            else {
                newColumns.push(column);
            }
        });
    };
    flatten(columns);
    return {
        level: level.length,
        columns: newColumns
    };
};
exports.flattenColumns = flattenColumns;
/**
 * 获取表头二维数组
 */
var getHeader2dArray = function (_a) {
    var columns = _a.columns, headerLevel = _a.headerLevel, _b = _a.childrenField, childrenField = _b === void 0 ? 'children' : _b;
    var arr = [];
    var deal = function (_columns, startCol, rowLevel) {
        if (startCol === void 0) { startCol = 0; }
        if (rowLevel === void 0) { rowLevel = 0; }
        _columns.reduce(function (prevCol, currentColumn) {
            if (!arr[rowLevel]) {
                arr[rowLevel] = [];
            }
            arr[rowLevel][prevCol] = currentColumn;
            var nextCol = prevCol;
            var childColumns = currentColumn[childrenField];
            if (childColumns) {
                deal(childColumns, prevCol, rowLevel + 1);
                var flatChildColumns = (0, exports.flattenColumns)({ columns: childColumns, childrenField: childrenField }).columns;
                nextCol += flatChildColumns.length;
                arr[rowLevel][prevCol].merges = {
                    s: { c: prevCol, r: rowLevel },
                    e: { c: nextCol - 1, r: rowLevel },
                };
                // 补全值 跨行的值
                for (var c = prevCol + 1; c < nextCol; c++) {
                    arr[rowLevel][c] = currentColumn;
                }
            }
            else {
                nextCol += 1;
                // 有跨列
                if (headerLevel - 1 - rowLevel > 0) {
                    arr[rowLevel][prevCol].merges = {
                        s: { c: prevCol, r: rowLevel },
                        e: { c: prevCol, r: headerLevel - 1 },
                    };
                    // 补全值 跨列的值
                    for (var r = rowLevel + 1; r < headerLevel; r++) {
                        if (!arr[r]) {
                            arr[r] = [];
                        }
                        arr[r][prevCol] = currentColumn;
                    }
                }
            }
            return nextCol;
        }, startCol);
    };
    deal(columns);
    return arr;
};
exports.getHeader2dArray = getHeader2dArray;
/**
 * 获取列宽
 */
var formatToWpx = function (width) {
    var wpx = width || 100;
    if (typeof wpx === 'string') {
        wpx = Number(wpx.replace(/[^0-9]/ig, ''));
    }
    return wpx;
};
exports.formatToWpx = formatToWpx;
